<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listcompanies" class="blue-grey-text text-darken-4 strong">Security Master: Companies</router-link>
        >
        <span>View Mutual Fund</span>
      </section>
    </article>
    <h4>View Mutual Fund</h4>
    <table class="container">
      <tbody>
        <tr>
          <th>Recommendations</th>
          <td>
            <router-link :to="`/tickeradmin/viewrecommendations?instrument_id=${instrument.id}`">
              See Recommendations
            </router-link>
          </td>
        </tr>
        <tr>
          <th>Instrument ID</th>
          <td>{{ instrument.id }}</td>
        </tr>
        <tr>
          <th>CapIQ Trading Item ID</th>
          <td>{{ instrument.capiq_trading_item_id }}</td>
        </tr>
        <tr>
          <th>Exchange</th>
          <td v-if="instrument.asset_class === 'Equity'">{{ instrument.exchange.symbol }}</td>
          <td v-if="instrument.asset_class === 'Mutual Fund'">MutualFund</td>
        </tr>
        <tr>
          <th>Symbol</th>
          <td>{{ instrument.symbol }}</td>
        </tr>
        <tr>
          <th>Quotes Symbol</th>
          <td>{{ instrument.quotes_symbol || '-' }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ instrument.name }}</td>
        </tr>
        <tr>
          <th>Is Active</th>
          <td>
            <i class="fas fa-times-circle red-text" v-if="instrument.inactive_date" />
            <i class="fas fa-check-circle green-text" v-else />
          </td>
        </tr>
        <tr v-if="instrument.inactive_date">
          <th>Inactive Date</th>
          <td>{{ instrument.inactive_date }}</td>
        </tr>
        <tr>
          <th>Is Primary</th>
          <td>
            <i class="fas fa-check-circle green-text" v-if="instrument.is_primary" />
            <i class="fas fa-times-circle red-text" v-else />
          </td>
        </tr>
        <tr>
          <th>IQ Included</th>
          <td>
            <i class="fas fa-check-circle green-text" v-if="instrument.iq_include" />
            <i class="fas fa-times-circle red-text" v-else />
          </td>
        </tr>
        <tr>
          <th>Synced with Xpressfeed</th>
          <td>
            <i class="fas fa-check-circle green-text" v-if="instrument.synced_with_xpressfeed" />
            <i class="fas fa-times-circle red-text" v-else />
          </td>
        </tr>
      </tbody>
    </table>
    <aside class="usm-edit-instrument-aside" v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')">
      <router-link :to="`/tickeradmin/editinstrument?instrument_id=${instrument.id}`"
                   v-if="instrument.asset_class === 'Equity'">
        <button class="btn-floating btn-large waves-effect waves-light amber accent-3">
          <i class="fas fa-edit" />
        </button>
        <label>Edit Instrument</label>
      </router-link>
      <router-link :to="`/tickeradmin/editmutualfund?instrument_id=${instrument.id}`"
                   v-if="instrument.asset_class === 'Mutual Fund'">
        <button class="btn-floating btn-large waves-effect waves-light amber accent-3">
          <i class="fas fa-edit" />
        </button>
        <label>Edit Mutual Fund</label>
      </router-link>
    </aside>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TickerAdminViewInstrument',
  data() {
    return {
      instrument: { exchange: {}, security_class: {} },
    };
  },
  computed: {
    instrumentId() {
      return this.$route.query.instrument_id || 0;
    },
  },
  methods: {
    async fetchInstrument() {
      try {
        const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/mutual_fund/${this.instrumentId}/`);
        this.instrument = data[0];
      } catch (err) {
        console.log('no mutual fund found');
      }
    },
  },
  mounted() {
    this.fetchInstrument();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

nav {
  padding-left: 20px;
}

.usm-edit-instrument-aside {
  position: absolute;
  top: 30px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}
</style>
